/**
 * Converts a string to a URL-friendly slug
 * @param {string} text - The text to convert to a slug
 * @returns {string} - URL-friendly slug
 */
export const slugify = (text) => {
  if (!text) return "";

  // Convert to lowercase, replace spaces with hyphens, remove special chars
  return text
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^\w\-]+/g, "") // Remove non-word chars (except hyphens)
    .replace(/\-\-+/g, "-") // Replace multiple hyphens with single hyphen
    .replace(/^-+/, "") // Trim hyphens from start
    .replace(/-+$/, ""); // Trim hyphens from end
};

/**
 * Extracts post ID from a slug that has ID appended
 * @param {string} slug - The slug containing an ID at the end
 * @returns {string} - The extracted ID
 */
export const extractIdFromSlug = (slug) => {
  if (!slug) return "";

  // The ID is assumed to be the part after the last hyphen
  const parts = slug.split("-");
  return parts[parts.length - 1];
};
